import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./ZleceniaStyle/FormularzZlecenia.css";
import KosztySprzedazTabela from "./KosztySprzedazTabela";

//Zmiana formatu daty - FUNKCJA POMOCNICZA
function formatDateForInput(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const tzOffset = date.getTimezoneOffset() * 60000; 
    const localDate = new Date(date - tzOffset);
    return localDate.toISOString().slice(0, 16); 
  }

const API_URL = process.env.REACT_APP_API_URL;

function FormularzZlecenia({ uzytkownik, onZamknij, refreshZlecenia, clientId, defaultAddress, continuation, towary, slowniki }) {
    const [krok, setKrok] = useState(clientId ? 2 : 1 );
    const [selectedClient, setSelectedClient] = useState(clientId || null);
    const [adresy, setAdresy] = useState([]);
    const [adresWybrany, setAdresWybrany] = useState(null);
    const [urzadzenia, setUrzadzenia] = useState([]); 
    const [selectedUrzadzenia, setSelectedUrzadzenia] = useState([]); 
    const [klienci, setKlienci] = useState([]);
    const [search, setSearch] = useState("");
    const [pracownicy, setPracownicy] = useState([]);
    const [formData, setFormData] = useState({
        rodzaj_zlecenia: "Serwis",
        planowana_data_realizacji: "",
        status: continuation ? 'Kontynuacja' : 'Nowe',
        opis: "",
        cena: 0,
        koszt_praca: 0,
        koszt_materialy: 0,
        koszt_urzadzenia: 0,
        koszt_dojazd: 0,
        rabat_specjalny: 0,
        opiekun_zlecenia: uzytkownik.id,
        urzadzenia: [],
        pracownicy: [],
        id_adres: null
    });
    const [orderFiles, setOrderFiles] = useState([]);
    const [existingOrderFiles, setExistingOrderFiles] = useState([]);
    const [uploadingOrderFiles, setUploadingOrderFiles] = useState(false);
    const fileInputOrderRef = useRef(null);

    const [costRows, setCostRows] = useState([]);
    // jeżeli edytujesz istniejące zlecenie i wczytujesz pozycje z API,
    // ustaw to na starcie:
    const initialCostIdsRef = useRef([]); // np. = loadedCosts.map(r => r.id_koszt)

    // jeżeli otwarto w trybie kontynuacji → krok 3 & znane ID-klienta / adresu
    useEffect(() => {
        if (continuation) {
        setSelectedClient(continuation.id_klient);
        setAdresWybrany(continuation.id_adres);
        setKrok(3);
        // pobieramy pliki poprzedniego zlecenia
        (async () => {
            try {
            const token = localStorage.getItem("token");
            const res = await axios.get(
                `${API_URL}/pliki_zlecenia/zlecenia?id_zlecenia=${continuation.id_zlecenia}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setExistingOrderFiles(res.data); // <- używamy istniejącego stanu miniatur
            } catch (e) { console.error(e); }
        })();
        }
    }, [continuation]);

    useEffect(() => {
        if (clientId) {
          setSelectedClient(clientId);
          // Możesz ustawić krok na 2 lub 3, w zależności od logiki wyboru adresu.
          setKrok(2);
        }
      }, [clientId]);


    //// Wyszukiwanie klientów
   useEffect(() => {
    if (!clientId && search.length > 2) {
      const fetchKlienci = async () => {
        try {
          const token = localStorage.getItem('token');
          const res = await axios.get(`${API_URL}/klienci/search?search=${search}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setKlienci(res.data);
        } catch (err) {
          console.error("❌ Błąd pobierania klientów:", err);
          alert("Nie udało się pobrać klientów.");
        }
      };

      const debounce = setTimeout(fetchKlienci, 500);
      return () => clearTimeout(debounce);
    } else if (clientId) {
      // Gdy clientId jest przekazany, nie wykonujemy wyszukiwania.
      setKlienci([]);
    }
  }, [search, clientId]);


    // 🔄 Pobieranie adresów klienta
    useEffect(() => {
        if (selectedClient) {
            const token = localStorage.getItem('token'); // Pobranie tokena
            
            axios.get(`${API_URL}/adresy?id_klient=${selectedClient}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                console.log("✅ Otrzymane adresy:", res.data);
                setAdresy(res.data);
            })
            .catch(err => {
                console.error("❌ Błąd pobierania adresów:", err);
                alert("Błąd autoryzacji lub serwera podczas pobierania adresów.");
            });
        }
    }, [selectedClient]);

    // 🔄 Pobieranie urządzeń dla klienta i adresu
    useEffect(() => {
        if (selectedClient && adresWybrany) {
            const token = localStorage.getItem('token');
            axios
                .get(`${API_URL}/urzadzenia?id_klient=${selectedClient}&id_adres=${adresWybrany}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(res => {
                    console.log("📡 Otrzymane urządzenia:", res.data);
                    setUrzadzenia(res.data);
                })
                .catch(err => {
                    console.error("❌ Błąd pobierania urządzeń:", err);
                });
        }
    }, [selectedClient, adresWybrany]);
    

    // 🔄 Pobieranie pracowników
    useEffect(() => {
        const token = localStorage.getItem('token');
        
        axios.get(`${API_URL}/pracownicy`, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
            console.log("✅ Otrzymani pracownicy:", res.data);
            setPracownicy(res.data.filter(p => p.id_pracownika !== null));
        })
        .catch(err => {
            console.error("❌ Błąd pobierania pracowników:", err);
            alert("Błąd autoryzacji lub serwera podczas pobierania pracowników.");
        });
    }, []);

    // Zmiana statusu w zależności od tego czy przypisany jest pracownik
    useEffect(() => {
        if (continuation) return;
        if (formData.pracownicy.length > 0) {
            setFormData((prev) => ({ ...prev, status: "W realizacji" }));
        } else {
            setFormData((prev) => ({ ...prev, status: "Nowe" }));
        }
    }, [formData.pracownicy]); 
    
    

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        // 📌 Jeśli pole to cena/koszty, upewniamy się, że nie ma wartości ujemnych
        if (["cena", "koszt_praca", "koszt_materialy", "koszt_urzadzenia", "koszt_dojazd"].includes(name)) {
            setFormData({ ...formData, [name]: value < 0 ? 0 : value });
        } 
        // 📌 Jeśli pole to rabat, sprawdzamy czy jest między 0 a 100
        else if (name === "rabat_specjalny") {
            setFormData({ ...formData, [name]: value < 0 ? 0 : value > 100 ? 100 : value });
        } 
        else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // ➕ Dodawanie urządzenia do listy przypisanych
    const handleAddUrzadzenie = (id_urzadzenie) => {
        const urzadzenie = urzadzenia.find(u => u.id_urzadzenie === id_urzadzenie);
        if (urzadzenie && !selectedUrzadzenia.find(u => u.id_urzadzenie === id_urzadzenie)) {
            setSelectedUrzadzenia([...selectedUrzadzenia, urzadzenie]);
        }
    };

    // ❌ Usuwanie urządzenia z listy przypisanych
    const handleRemoveUrzadzenie = (id_urzadzenie) => {
        setSelectedUrzadzenia(selectedUrzadzenia.filter(u => u.id_urzadzenie !== id_urzadzenie));
    };

    const handleAddPracownik = (id_pracownika) => {
        if (!formData.pracownicy.includes(id_pracownika)) {
            setFormData((prev) => ({
                ...prev,
                pracownicy: [...prev.pracownicy, id_pracownika],
                status: "W realizacji" // ✅ Status zmienia się automatycznie
            }));
        }
    };

    const handleRemovePracownik = (id_pracownika) => {
        setFormData((prev) => {
            const updatedPracownicy = prev.pracownicy.filter((p) => p !== id_pracownika);
            return {
                ...prev,
                pracownicy: updatedPracownicy,
                status: updatedPracownicy.length > 0 ? "W realizacji" : "Nowe" // ✅ Status wraca na "Nowe" jeśli nie ma pracowników
            };
        });
    };

    const handleChooseOrderFilesClick = () => fileInputOrderRef.current.click();

    const handleOrderFilesChange = e => {
    const files = Array.from(e.target.files);
    setOrderFiles(prev =>
        [...prev, ...files].filter((f,i,arr) =>
        arr.findIndex(x=>x.name===f.name&&x.size===f.size)===i
        )
    );
    };

    const handleRemoveOrderFile = idx => {
    setOrderFiles(prev => prev.filter((_,i)=>i!==idx));
    };

    const handleUploadOrderFiles = async orderId => {
    if (!orderFiles.length) return;
    setUploadingOrderFiles(true);
    const token = localStorage.getItem("token");
    try {
        await Promise.all(orderFiles.map(file => {
        const fd = new FormData();
        fd.append("plik", file);
        fd.append("nazwa_pliku", file.name);
        fd.append("idPowiazania", orderId);
        return axios.post(
            `${API_URL}/pliki_zlecenia/upload/zlecenie`,
            fd,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        }));
        setOrderFiles([]);
        // odśwież existingOrderFiles, np. fetch ponownie
    } catch (err) {
        console.error(err);
        alert("Błąd uploadu plików zlecenia");
    } finally {
        setUploadingOrderFiles(false);
    }
    };

    const toNum = (v) => {
        if (v === "" || v == null) return NaN;
        const n = Number(String(v).replace(",", "."));
        return Number.isFinite(n) ? n : NaN;
        };
    const isQtyValid = (q) => {
        const n = toNum(q);
        return Number.isFinite(n) && n > 0;
        };
    const buildKosztPayload = (row, id_zlecenie) => ({
        // wymagane
        id_zlecenie,
        nazwa_at_sale: row.nazwa_at_sale,
        ilosc: toNum(row.ilosc),
        koszt_jednostkowy_netto_at_sale: toNum(row.koszt_jednostkowy_netto_at_sale),
        // snapshot / opcjonalne
        in_sprzedaz: !!row.in_sprzedaz,
        id_towar: row.id_towar ?? null,
        kategoria_id: row.kategoria_id ?? null,
        jednostka_id: row.jednostka_id ?? null,
        vat_proc_at_sale: row.vat_proc_at_sale ?? null,
        vat_id: row.vat_id ?? null,
        marza_at_sale: row.marza_at_sale != null ? toNum(row.marza_at_sale) : null,
        jednostka_symbol_at_sale: row.jednostka_symbol_at_sale || null,
        kategoria_nazwa_at_sale: row.kategoria_nazwa_at_sale || null,
        vat_nazwa_at_sale: row.vat_nazwa_at_sale || null,
        });

    async function saveCostsForOrder(id_zlecenia) {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // tylko kompletne wiersze
        const rowsToPersist = costRows.filter(
            r => r.id_towar && isQtyValid(r.ilosc) && r.nazwa_at_sale
        );

        // jeśli chcesz blokować submit gdy ktoś coś wpisał, ale nie wybrał z listy:
        const invalid = costRows.filter(r =>
            (r.nazwa_at_sale?.trim() && !r.id_towar) || (r.id_towar && !isQtyValid(r.ilosc))
        );
        if (invalid.length) {
            throw new Error('W kosztach są wiersze z błędami (wybierz nazwę z listy i ilość > 0).');
        }

        const currentIds = new Set(rowsToPersist.filter(r => r.id_koszt).map(r => r.id_koszt));
        const originalIds = new Set(initialCostIdsRef.current || []);
        const toDelete = [...originalIds].filter(id => !currentIds.has(id));

        const createReqs = rowsToPersist
            .filter(r => !r.id_koszt)
            .map(r => axios.post(`${API_URL}/koszty-pozycje`, buildKosztPayload(r, id_zlecenia), { headers }));

        const updateReqs = rowsToPersist
            .filter(r => r.id_koszt)
            .map(r => axios.put(`${API_URL}/koszty-pozycje/${r.id_koszt}`, buildKosztPayload(r, id_zlecenia), { headers }));

        const deleteReqs = toDelete.map(id => axios.delete(`${API_URL}/koszty-pozycje/${id}`, { headers }));

        await Promise.all([...createReqs, ...updateReqs, ...deleteReqs]);
        }

    const hasEditing = costRows.some(r => r.isEditing);
    const hasInvalidCost = costRows.some(r => {
    const typedName = (r.nazwa_at_sale || '').trim().length > 0;
    const hasId = !!r.id_towar;
    const qtyOk = isQtyValid(r.ilosc);
    // blokuj, jeśli użytkownik coś wpisał, ale nie wybrał z listy,
    // albo wybrał z listy, ale ilość niepoprawna
    return (typedName && !hasId) || (hasId && !qtyOk);
    });

    const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const token = localStorage.getItem('token');
        const jsonHeaders = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json',
        };

        if (!adresWybrany) {
        alert("Musisz wybrać adres klienta!");
        return;
        }

        // 1) tworzenie zlecenia
        const response = await axios.post(
        `${API_URL}/zlecenia`,
        {
            ...formData,
            id_klienta: selectedClient,
            id_adres: adresWybrany,
            opiekun_zlecenia: formData.opiekun_zlecenia || uzytkownik.id_pracownika,
            planowana_data_realizacji: formData.planowana_data_realizacji
            ? new Date(formData.planowana_data_realizacji).toISOString()
            : null,
            urzadzenia: selectedUrzadzenia.map(u => u.id_urzadzenie),
            data_realizacji_od: formData.data_realizacji_od
            ? new Date(formData.data_realizacji_od).toISOString()
            : null,
            data_realizacji_do: formData.data_realizacji_do
            ? new Date(formData.data_realizacji_do).toISOString()
            : null,
        },
        { headers: jsonHeaders }     // ⬅⬅⬅ TU
        );

        const id_zlecenia = response.data.id_zlecenia;

        // 2) pracownicy
        if (formData.pracownicy.length > 0) {
        await axios.post(
            `${API_URL}/zleceniapracownicy`,
            { id_zlecenia, pracownicy: formData.pracownicy },
            { headers: jsonHeaders }   // ⬅⬅⬅ TU
        );
        }

        // 3) koszty
        await saveCostsForOrder(id_zlecenia); // (wewnątrz też użyj jsonHeaders)

        // 4) urządzenia
        if (selectedUrzadzenia.length > 0) {
        await axios.post(
            `${API_URL}/zleceniaurzadzenia`,
            { id_zlecenia, urzadzenia: selectedUrzadzenia.map(u => u.id_urzadzenie) },
            { headers: jsonHeaders }   // ⬅⬅⬅ TU
        );
        }

        alert("Zlecenie zostało dodane!");
        await handleUploadOrderFiles(id_zlecenia);
        onZamknij();
    } catch (err) {
        console.error("Błąd dodawania zlecenia:", err);
        alert("Nie udało się dodać zlecenia.");
    }
    };


    
    
   

    return (
        <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={onZamknij}>X</button>
                <h3>
                {continuation
                ? `Kontynuacja do zlecenia: ${continuation.numer_zlecenia}`
                : 'Dodaj nowe zlecenie'}
                </h3>

                {/* Krok 1: Wybór klienta */}
                {krok === 1 && (
                    <>
                        <input
                            type="text"
                            placeholder="Wyszukaj klienta..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <ul className="client-list">
                            {klienci
                                .filter((klient, index, self) =>
                                    index === self.findIndex((k) => k.id_klient === klient.id_klient)
                                )
                                .map((klient) => (
                                    <li key={klient.id_klient} 
                                        className={`client-item ${selectedClient === klient.id_klient ? 'selected' : ''}`}
                                        onClick={() => setSelectedClient(klient.id_klient)}
                                    >
                                        <input 
                                            type="radio" 
                                            name="selectedClient"
                                            checked={selectedClient === klient.id_klient}
                                            onChange={() => setSelectedClient(klient.id_klient)}
                                        />
                                        <div className="client-details">
                                            <strong>{klient.imie} {klient.nazwisko}</strong><br />
                                            {klient.adres_email} | {klient.nr_telefonu} <br />
                                            {klient.miasto ? `${klient.miasto}, ${klient.ulica} ${klient.nr_domu}, ${klient.kod_pocztowy}` : "Brak adresu"}
                                        </div>
                                    </li>
                                ))}
                        </ul>

                        <button disabled={!selectedClient} onClick={() => setKrok(2)}>Dalej</button>
                    </>
                )}

                {/* Krok 2: Wybór adresu */}
                {krok === 2 && (
                    <>
                        <h4>Wybierz adres klienta</h4>
                        <ul className="client-list">
                            {adresy.map((adres) => (
                                <li 
                                    key={adres.id_adres} 
                                    className={`client-item ${adresWybrany === adres.id_adres ? 'selected' : ''}`}
                                    onClick={() => setAdresWybrany(adres.id_adres)}
                                >
                                    <input 
                                        type="radio" 
                                        name="adres" 
                                        checked={adresWybrany === adres.id_adres}
                                        onChange={() => setAdresWybrany(adres.id_adres)}
                                    />
                                    <div className="client-details">
                                        <strong>{adres.miasto}, {adres.ulica} {adres.nr_domu}</strong><br />
                                        Kod pocztowy: {adres.kod_pocztowy} <br />
                                        {adres.nr_lokalu ? `Lokal: ${adres.nr_lokalu}` : ""}
                                    </div>
                                </li>
                            ))}
                        </ul>

                        <button onClick={() => setKrok(1)}>Wstecz</button>
                        <button disabled={!adresWybrany} onClick={() => setKrok(3)}>Dalej</button>
                    </>
                )}

                {continuation && krok === 3 && (
                <div className="continuation-info">
                    <h4>Dane poprzedniego zlecenia</h4>
                    <p><strong>Numer poprzedniego zlecenia:</strong> #{continuation.numer_zlecenia}</p>
                    <p><strong>Opis:</strong> {continuation.opis || '—'}</p>
                    {/* NOWOŚĆ ↓↓↓ */}
                    <p><strong>Opis wykonanych prac:</strong> {continuation.opis_prac || '—'}</p>
                    {/* ─────── */}

                    <p>
                    <strong>Czas realizacji zlecenia</strong>{' '}
                    <p className="order-time">Od: </p>
                    {continuation.data_realizacji_do
                        ? new Date(continuation.data_realizacji_do).toLocaleString()
                        : '—'}
                    <p className="order-time"> | Do: </p>
                    {continuation.data_realizacji_od
                        ? new Date(continuation.data_realizacji_od).toLocaleString()
                        : '—'}
                    </p>

                    <h5>Pliki z poprzedniego zlecenia</h5>
                    <div className="thumbnails">
                    {existingOrderFiles.map(f => (
                        <MiniaturaPliku
                        key={f.id_pliku}
                        file={f}
                        apiUrl={API_URL}
                        />
                    ))}
                    </div>
                </div>
                )}


                { krok === 3 && (
                    <form onSubmit={handleSubmit}>
                        <h4>Uzupełnij dane zlecenia</h4>

                        <div className="form-row">
                            <div>
                                <label>Rodzaj zlecenia:</label>
                                <select name="rodzaj_zlecenia" onChange={handleChange} value={formData.rodzaj_zlecenia}>
                                    <option>Serwis</option>
                                    <option>Przegląd</option>
                                    <option>Montaż</option>
                                    <option>Audyt</option>
                                    <option>Wizja</option>
                                    <option>Sprzedaż</option>
                                    <option>Inne</option>
                                </select>
                            </div>

                            <div>
                                <label>Planowana data realizacji:</label>
                                <input type="datetime-local" name="planowana_data_realizacji" onChange={handleChange} required />
                            </div>


                            <div>
                                <label>Status:</label>
                                <select 
                                    name="status" 
                                    value={formData.status} 
                                    disabled
                                >   
                                    <option>Nowe</option>
                                    <option>W realizacji</option>
                                    <option>Zrealizowane</option>
                                    <option>Rozliczone</option>
                                    <option>Anulowane</option>
                                    <option value="Kontynuacja" disabled>Kontynuacja</option>
                                </select>
                            </div>

                            

                        </div>

                        <div className="form-row">
                            <div className="">
                                <label>Przypisz pracowników:</label>
                                <select 
                                    onChange={(e) => {
                                        const selectedId = parseInt(e.target.value); // Upewniamy się, że to liczba
                                        if (selectedId && !formData.pracownicy.includes(selectedId)) {
                                            setFormData(prevState => ({
                                                ...prevState,
                                                pracownicy: [...prevState.pracownicy, selectedId]
                                            }));
                                        }
                                    }}
                                >
                                    <option value="">Wybierz pracownika</option>
                                    {pracownicy.map((p) => (
                                        <option key={p.id_pracownika} value={p.id_pracownika}>
                                            {p.imie} {p.nazwisko}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label>Dodaj urządzenie:</label>
                                <select onChange={(e) => handleAddUrzadzenie(parseInt(e.target.value))}>
                                <option value="">Wybierz urządzenie</option>
                                {urzadzenia.map((u) => (
                                    <option key={u.id_urzadzenie} value={u.id_urzadzenie}>
                                        {u.nazwa} - {u.model} (SN: {u.numer_seryjny})
                                    </option>
                                ))}
                            </select>
                            </div>

                            <div>
                                <label>Opis:</label>
                            </div>

                        </div>


                        <div className="form-row">

                            <div className="selected-items">
                                {formData.pracownicy.map((id) => {
                                    const pracownik = pracownicy.find(p => p.id_pracownika === id);
                                    return pracownik ? (
                                        <div key={id} className="selected-item">
                                            {pracownik.imie} {pracownik.nazwisko}
                                            <button type="button" onClick={() => {
                                                setFormData(prevState => ({
                                                    ...prevState,
                                                    pracownicy: prevState.pracownicy.filter(p => p !== id)
                                                }));
                                            }}>❌</button>
                                        </div>
                                    ) : null;
                                })}
                            </div>

                            {/* Lista dodanych urządzeń */}
                        <div className="selected-items">
                            {selectedUrzadzenia.map((u) => (
                                <div key={u.id_urzadzenie} className="selected-item">
                                    {u.nazwa} - {u.model} (SN: {u.numer_seryjny})
                                    <button onClick={() => handleRemoveUrzadzenie(u.id_urzadzenie)}>✖</button>
                                </div>
                            ))}
                        </div>

                        <div>
                            <textarea name="opis" onChange={handleChange} value={formData.opis}></textarea>
                        </div>


                        </div>


                        <KosztySprzedazTabela
                            towary={towary}
                            slowniki={slowniki}
                            onChange={setCostRows}
                        />

                        

                        <div className="order-files-section">
                            <h4>Załącz pliki do zlecenia</h4>
                            <input
                                type="file" multiple
                                accept=".pdf,.jpeg,.jpg,.png,.tiff,.docx,.xlsx"
                                ref={fileInputOrderRef}
                                style={{display:'none'}}
                                onChange={handleOrderFilesChange}
                            />
                            <button type="button" onClick={handleChooseOrderFilesClick}>
                                Wybierz pliki
                            </button>
                            {orderFiles.length > 0 && (
                                <div className="thumbnails">
                                {orderFiles.map((file,idx) => {
                                    const url = URL.createObjectURL(file);
                                    return (
                                    <div key={idx} className="thumb">
                                        <img src={url} alt={file.name} />
                                        <button
                                        type="button"
                                        className="remove-thumb"
                                        onClick={() => handleRemoveOrderFile(idx)}
                                        >✖</button>
                                    </div>
                                    );
                                })}
                                </div>
                            )}
                            </div>


                        <div className="buttons-container">
                            <button onClick={() => setKrok(2)}>Wstecz</button>
                            <button type="submit">Dodaj zlecenie</button>
                        </div>
                    </form>
                )}

            </div>
        </div>
    );
}

export default FormularzZlecenia;


const MiniaturaPliku = ({ file, apiUrl }) => {
    const [url,setUrl] = useState(null);
    useEffect(() => {
      const fetch = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await axios.get(
            `${apiUrl}/pliki_zlecenia/${file.id_pliku}`,
            { responseType:'blob', headers:{Authorization:`Bearer ${token}`} }
          );
          setUrl(URL.createObjectURL(res.data));
        } catch(e){ console.error(e); }
      };
      fetch();
      return () => url && URL.revokeObjectURL(url);
    }, []);
    if (!url) return <div className="thumb skeleton" />;
    return (
      <div className="thumb" onClick={() => window.open(url, '_blank')}>
        {file.typ_pliku.startsWith('image/')
          ? <img src={url} alt={file.nazwa_oryginalna}/>
          : <object data={url} type="application/pdf" width="100%" height="100%">PDF</object>}
      </div>
    );
  };




